import moment from 'moment'
export const month = [
  'Enero',
  'Febrero',
  'Marzo',
  'Abril',
  'Mayo',
  'Junio',
  'Julio',
  'Agosto',
  'Septiembre',
  'Octubre',
  'Noviembre',
  'Diciembre'
]

export const dateFormat = (value, hours = true) => {
  if (!value) return value
  const [year, month, day] = value.split('T')[0].split('-')
  // const [hour, minutes, seconds]  = value.split('T')[1].split('.')[0].split(':')
  const temporal_date = new Date(value)
  let hour = temporal_date
    .getHours()
    .toString()
    .padStart(2, '0')
  let minutes = temporal_date
    .getMinutes()
    .toString()
    .padStart(2, '0')
  if (hours) {
    return `${day}/${month}/${year} - ${hour}:${minutes}`
    // return temporal_date.getDate().toString().padStart(2, '0') + '/' +
    //   (temporal_date.getMonth() + 1).toString().padStart(2, '0') + '/' +
    //   temporal_date.getFullYear() + ' ' + `${hour}:${minutes}`
  }
  return `${day}/${month}/${year}`
  // return temporal_date.getDate().toString().padStart(2, '0') + '/' +
  //   (temporal_date.getMonth() + 1).toString().padStart(2, '0') + '/' +
  //   temporal_date.getFullYear()
}

export const timeFormat = (value, ifSeconds = true) => {
  if (!value) return value
  // const [hour, minutes, seconds]  = value.split('T')[1].split('.')[0].split(':')
  const temporal_time = new Date(value)
  let hour = temporal_time
    .getHours()
    .toString()
    .padStart(2, '0')
  let minutes = temporal_time
    .getMinutes()
    .toString()
    .padStart(2, '0')
  if (!ifSeconds) return `${hour}:${minutes}`
  let seconds = temporal_time
    .getSeconds()
    .toString()
    .padStart(2, '0')
  return `${hour}:${minutes}:${seconds}`
}

export const formatDatePicker = value => {
  if (!value) return value
  return moment(value.split('T')[0])
    .add(1, 'minute')
    .format('YYYY-MM-DD')
}

// Recibe YYYY-MM-DD
export const formatDate = (date, time = false) => {
  if (!date || !moment(date).isValid()) return ''
  if (time) {
    return moment(date)
      .add(1, 'minute')
      .format('DD-MMM-YYYY h:mm a')
  } else {
    let dateTemp = date
    if (typeof dateTemp === 'string' && dateTemp.includes('T')) {
      dateTemp = dateTemp.split('T')[0]
    }
    return moment(dateTemp)
      .add(1, 'minute')
      .format('DD-MMM-YYYY')
  }
}

export const parseTime = value => {
  if (!value) return value
  let time = new Date()
  const [hour, minutes] = value.split(':')
  time.setHours(hour, minutes)
  return time
}
